import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from '../Section';
import styles from './Common.module.css'

class PatientCareCenterNotePlanOdg extends React.Component {

    render() {
        if (this.props.isWc && (this.props.generalDesc || this.props.odgDetails)) {
            return (
                <PatientCareCenterNoteSection id='plan_odg' name='Occupational Disability Guidelines (ODG)*' level={2}>
                    {this.props.generalDesc &&
                        <span className={styles.row}>
                            <span className={styles.col1}>General Guideline:</span>
                            <span className={styles.col2}>{this.props.generalDesc}</span>
                        </span>
                    }
                    {this.props.odgDetails &&
                        <span>
                            <span className={styles.row}>
                                <span className={styles.col1}>Medical Treatment:</span>
                                <span className={styles.col2}>{this.props.odgDetails.ODMEDTREATMENT}</span>
                            </span>
                            <span className={styles.row}>
                                <span className={styles.col1}>Post-Surgical Treatment:</span>
                                <span className={styles.col2}>{this.props.odgDetails.ODPOSTSURGERYTREATMENT}</span>
                            </span>
                            <span className={styles.row}>
                                <span className={styles.col1}>Avg. RTW:</span>
                                <span className={styles.col2}>{this.props.odgDetails.ODAVGRTW}</span>
                            </span>
                            <span className={styles.row}>
                                <span className={styles.col1}>At-Risk RTW:</span>
                                <span className={styles.col2}>{this.props.odgDetails.ODATRISKRTW}</span>
                            </span>
                        </span>
                    }
                    <span className={styles.row}>
                        <label className={styles.asterisk}>* Visit recommendations are an evidence based guideline.  It is not to be interpreted as a visit minimum or maximum.</label>
                    </span>
                </PatientCareCenterNoteSection>
            );
        } else {
            return (
                <span />
            )
        }
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let bodyPart = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVSUBWCBODYPART : state.entities.notes.PTNOTE[pk].NTSUBWCBODYPART;
    let odg = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVSUBWCODG : state.entities.notes.PTNOTE[pk].NTSUBWCODG;
    let generalDesc = bodyPart ? state.entities.masterData.CWEVALTYPES[bodyPart].TPODGDESC : undefined;
    let odgDetails = odg ? state.entities.masterData.CWODGDETAILS[odg] : undefined;

    return {
        noteId,
        epno,
        isWc: state.entities.admissions[epno].isWc,
        generalDesc,
        odgDetails
    };
}

const connectedPatientCareCenterNotePlanOdg = connect(mapStateToProps)(PatientCareCenterNotePlanOdg);
export { connectedPatientCareCenterNotePlanOdg as PatientCareCenterNotePlanOdg };

